var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChangeorders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.3 26.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.39,3.13H2.86V13.66H13.39Z",
    transform: "translate(-2.86 -2.33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.61,17.87h3.16V20H17.61Z",
    transform: "translate(-2.86 -2.33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.82,17.87H25V20H21.82Z",
    transform: "translate(-2.86 -2.33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,17.87h2.11V21H26Z",
    transform: "translate(-2.86 -2.33)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.61,25.25h2.1V28.4h-2.1Z",
    transform: "translate(-2.86 -2.33)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.77,26.3h3.16v2.1H20.77Z",
    transform: "translate(-2.86 -2.33)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,26.3h3.16v2.1H25Z",
    transform: "translate(-2.86 -2.33)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.61,21h2.1v3.16h-2.1Z",
    transform: "translate(-2.86 -2.33)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,22.09h2.11v3.16H26Z",
    transform: "translate(-2.86 -2.33)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.29,24.06V21.33L15.91,25l-3.62,3.67V25.9a7,7,0,0,1-5.15-2.16A7,7,0,0,1,5,18.6a6.91,6.91,0,0,1,1.16-3.89L7.46,16a5.2,5.2,0,0,0-.64,2.56A5.46,5.46,0,0,0,12.29,24Z",
    transform: "translate(-2.86 -2.33)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.66,5.1a7,7,0,0,1,5.15,2.16,7.14,7.14,0,0,1,1,9L23.48,15a5.08,5.08,0,0,0,.65-2.56,5.26,5.26,0,0,0-1.61-3.86A5.21,5.21,0,0,0,18.66,7V9.67L15,6l3.63-3.67V5.1Z",
    transform: "translate(-2.86 -2.33)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeorders);
export default __webpack_public_path__ + "static/media/icon-changeorders.e2f77ed36af3d6537ab3e6f078752d28.svg";
export { ForwardRef as ReactComponent };